module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/fronts/2m-98a5fcddec20119e061ff57bef87e3e3.jpg";